module.exports = __webpack_public_path__ + "img/Account.5450e43c.svg";